import { api } from './api';

export type ReportPeriodParams = {
  date_from?: string;
  date_to?: string;
  pool_id?: number;
  limit?: number;
};

function qs(params: ReportPeriodParams = {}) {
  const p: Record<string, string | number> = {};
  if (params.date_from) p.date_from = params.date_from;
  if (params.date_to) p.date_to = params.date_to;
  if (params.pool_id != null && !Number.isNaN(Number(params.pool_id))) {
    p.pool_id = Number(params.pool_id);
  }
  if (params.limit != null) p.limit = Number(params.limit);
  return p;
}

function errMessage(err: any, fallback: string): string {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join('; ');
  if (err?.message) return err.message;
  return fallback;
}

/** named axios(api) — 대시보드와 동일 인증 인터셉터 사용 */
async function getReport<T = any>(url: string, params?: ReportPeriodParams): Promise<T> {
  try {
    const res = await api.get<T>(url, { params: qs(params) });
    return res.data as T;
  } catch (err: any) {
    throw new Error(errMessage(err, `${url} 요청 실패`));
  }
}

export const reportsApi = {
  ping: () => getReport<{ ok: boolean }>('/api/reports/ping'),

  pools: () =>
    getReport<{ pools: { id: number; code: string; name: string }[] }>('/api/reports/pools'),

  centralOverview: (params?: ReportPeriodParams) =>
    getReport<any>('/api/reports/central/overview', params),

  centralEvents: (params?: ReportPeriodParams) =>
    getReport<any>('/api/reports/central/events', params),

  centralAlerts: (params?: ReportPeriodParams) =>
    getReport<any>('/api/reports/central/alerts', params),

  centralFalsePositives: (params?: ReportPeriodParams) =>
    getReport<any>('/api/reports/central/false-positives', params),

  centralBusyHours: (params?: ReportPeriodParams) =>
    getReport<any>('/api/reports/central/busy-hours', params),

  centralEventList: (params?: ReportPeriodParams & { limit?: number }) =>
    getReport<any>('/api/reports/central/event-list', params),

  poolOverview: (poolId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/pool/${poolId}/overview`, params),

  poolEvents: (poolId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/pool/${poolId}/events`, params),

  poolWearables: (poolId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/pool/${poolId}/wearables`, params),

  poolMembersActivity: (poolId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/pool/${poolId}/members-activity`, params),

  poolBusyHours: (poolId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/pool/${poolId}/busy-hours`, params),

  poolAlerts: (poolId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/pool/${poolId}/alerts`, params),

  memberOverview: (memberId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/member/${memberId}/overview`, params),

  memberBiometrics: (memberId: number, params?: ReportPeriodParams) =>
    getReport<any>(`/api/reports/member/${memberId}/biometrics`, params),
};
